// extracted by mini-css-extract-plugin
export default {"container":"EmailInput--container--vek-4","error":"EmailInput--error--xUGR-"};